Vue.component('notes', {
    data () {
        return {
            notes: [],

            loading: false,

            createForm: $.extend(true, new Form({
                data: {
                    name: ''
                }
            }), {}),

            search: '',

            tab: 'search',

            alert: null,

            deleteId: null
        };
    },

    mounted () {
        this.getNotes();
    },

    methods: {
        setTab (tab) {
            this.tab = tab;
        },

        getNotes () {
            this.loading = true;

            axios.get('/api/notes/index', {
                params: {
                    search: this.search
                }
            }).then(response => {
                this.loading = false;

                this.notes = response.data;
            });
        },

        update (note) {
            axios.post('/api/notes/update/', note).catch(error => {
                this.alert = {
                    type: "error",
                    message: error.response.data.message,
                    errors: error.response.data.errors
                };
            });
        },

        store () {
            Http.post('/api/notes/store', this.createForm).then(response => {
                this.createForm.resetForm();

                this.getNotes();

                this.setTab(response.id);
            });
        },

        deleteNote (id) {
            this.deleteId = id;
        },

        cancelDelete () {
            this.deleteId = null;
        },

        doDeleteNote () {
            axios.post('/api/notes/delete/' + this.deleteId).then(response => {
                this.getNotes();

                this.cancelDelete();

                this.setTab('search');
            });
        }
    }
});